import {Component, forwardRef, OnInit, ViewChild} from '@angular/core';
import {CompleterCmp, CompleterItem} from 'ng2-completer';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {SearchbarCompleterData} from "./searchbar.completer-data";
import {ActivatedRoute, Router} from '@angular/router';
import {GbgrundstueckService} from 'app/core/gb-api';
import {LinkComponent, NavTarget} from 'app/shared/components/link/link.component';
import {AppRestCompleterService} from 'app/core/services/app-rest-completer.service';
import {GrundstuecknummerPipe} from 'app/shared/pipes/simple/grundstuecknummer.pipe';
import {keysToTranslate} from 'i18n/keys-to-translate';
import {
  KompaktGebaeudeeingangsadressePipe
} from '../../../shared/kompaktdarstellung/gebaeudeeingangsadresse/kompakt-gebaeudeeingangsadresse-pipe';

@Component({
  selector: 'cap-search-bar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
  host: {
    "class": "form-control-component"
  },
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SearchbarComponent), multi: true},
    AppRestCompleterService,
  ]
})

export class SearchbarComponent implements OnInit {

  @ViewChild(CompleterCmp, {static: false})
  private completer: CompleterCmp;

  private value = '';

  private reset = false;

  dataService: SearchbarCompleterData;

  debounceTime = 500;
  isOpen = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private completerService: AppRestCompleterService,
              private translate: TranslateService,
              private grundstueckService: GbgrundstueckService,
              private grundstuecknummerPipe: GrundstuecknummerPipe,
              private gebaedeAdressePipe: KompaktGebaeudeeingangsadressePipe) {
  }


  ngOnInit() {
    this.dataService = new SearchbarCompleterData(this.grundstueckService, this.grundstuecknummerPipe, this.gebaedeAdressePipe);
    keysToTranslate<string>([
      'searchbar.placeholderText',
      'searchbar.searchingText',
      'searchbar.noResults'
    ]);
  }

  writeValue(id: string): void {
    if (id) {
      this.reset = false;
    } else if (!this.reset) {
      this.reset = true;
    }
  }

  onSelected(selectedItem: CompleterItem) {
    if (selectedItem) {
      this.value = selectedItem.title;
      const path = LinkComponent.getPath(NavTarget.NAV_GRUNDSTUECK_ES);
      this.router.navigate([path], {
        relativeTo: this.route,
        queryParams: {id: selectedItem.originalObject.grundstueckId.id}
      });

      this.reset = false;
    } else {
      this.value = '';
    }
  }

  onOpen(isOpen: boolean) {
    this.isOpen = isOpen;
  }

  emptyCompleter() {
    this.completer.value = "";
    this.onSelected(null);
  }
}
